import httpService from 'Api/http.service';

const { REACT_APP_FLEX_API_BASE_URL } = process.env;
const BASE_URL = `${REACT_APP_FLEX_API_BASE_URL}/v1/`;

/* ⚠️ FLEX API */
export const getTerminalListForLocation = (locationId) => {
  return httpService({
    url: `${BASE_URL}locations/${locationId}/terminals`,
    method: 'get',
  });
};

/* ⚠️ FLEX API */
export const createTerminalForLocation = (
  locationId,
  { regisText, terminalName, status },
) => {
  return httpService({
    url: `${BASE_URL}locations/${locationId}/terminals`,
    method: 'post',
    data: {
      terminal_registration_text: regisText,
      terminal_display_name: terminalName,
      status,
    },
  });
};

/* ⚠️ FLEX API */
export const updateTerminalForLocation = (
  locationId,
  { terminalName, status, id },
) => {
  return httpService({
    url: `${BASE_URL}terminals/${id}`,
    method: 'put',
    data: {
      terminal_display_name: terminalName,
      status,
    },
  });
};

// ⚠️ FLEX API
export const deleteTerminalForLocation = (terminalId) => {
  return httpService({
    url: `${BASE_URL}terminals/${terminalId}`,
    method: 'delete',
  });
};
